import React from "react";
import styles from "./style.module.css";

const LoadingButton = ({
  loading = false,
  disabled = false,
  title,
  icon,
  onClick,
  type = "button",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${styles.loading_btn} ${loading && styles.btn_loader}`}
      disabled={loading || disabled}
    >
      <span>{title}</span> {icon}
    </button>
  );
};

export default LoadingButton;
